import React from "react";
import styled from "styled-components";

import { EntryProvider } from "../contexts/EntryContext";
import { ValidationProvider } from "../contexts/ValidationContext";

import { Layout } from "../containers/Layout";
import { EntryTabs } from "./entry/EntryTabs";

export const entryCanvasId = "entry-canvas";

export const setHiddenEntryCanvasSize = (width, height) => {
    const container = document.getElementById(entryCanvasId + "-container");
    container.style.width = width + "px";
    container.style.height = height + "px";
};

const HiddenCanvasStyle = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    overflow: hidden;
    pointer-events: none;
    background-color: white;
    canvas {
        display: block;
    }
`;

export const Entry = ({ entryId, urlParam1, urlParam2 }) =>
    <>
        <HiddenCanvasStyle id={entryCanvasId + "-container"}>
            <canvas id={entryCanvasId} />
        </HiddenCanvasStyle>
        <Layout>
            <EntryProvider>
                <ValidationProvider>
                    <EntryTabs
                        entryId={entryId}
                        urlParam1={urlParam1}
                        urlParam2={urlParam2} />
                </ValidationProvider>
            </EntryProvider>
        </Layout>
    </>;